import React, { useRef } from "react";
import SVG from "react-inlinesvg";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import iconIconSearch from "../../assets/svg/icon-search.svg";

import styles from "./index.module.scss";

export const SearchNav = (): React.ReactNode => {
    const searchInputComponent = useRef<HTMLFormElement | null>(null);

    const toggleSearchView = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();

        if (!searchInputComponent.current) {
            return;
        }

        searchInputComponent.current.classList.toggle("hidden");
    };

    // Need link title since content is an image. See #13290
    return (
        <div className={styles.searchNavContent}>
            <div className={styles.searchNavSearch}>
                <form
                    ref={searchInputComponent}
                    className={concatClassNames([
                        styles.searchNavSearchInput,
                        "hidden",
                    ])}
                    action="/search/"
                    method="get"
                >
                    {/* TODO(i18n): Use t tagged template for placeholder: placeholder={t`Search`} */}
                    <input
                        className={styles.searchNavSearchInputText}
                        type="text"
                        name="query"
                        placeholder="Search"
                    />
                </form>
                {/* TODO(i18n): Use t tagged template for aria-label: aria-label={t`Toggle Search Menu`} */}
                <a
                    aria-label="Toggle Search Menu"
                    href="#"
                    onClick={(e) => {
                        toggleSearchView(e);
                    }}
                >
                    <SVG
                        className={styles.searchNavIcon}
                        src={iconIconSearch}
                    />
                </a>
            </div>
        </div>
    );
};
